import httpAPI from '@mirinae/lessons/modules/apis/http';
import { apiPaths } from '@mirinae/shared/defines/paths';

const MyLessonsAPI = (() => {
    function MyLessonsAPIConstructor(host) {
        this.apiHost = host || '';
    }

    MyLessonsAPIConstructor.prototype = {
        lessonList: (data) => {
            return httpAPI('', apiPaths.lessonList, { data });
        },
        getMyLessons: (data) => {
            return httpAPI('', apiPaths.getMyLessons, { data });
        },
        getLessonList: () => {
            return httpAPI('', apiPaths.getLessonList);
        },
        topLessons: (data) => {
            return httpAPI('', apiPaths.topLessons, { data });
        },
    };

    return MyLessonsAPIConstructor;
})();

export const myLessonsAPI = new MyLessonsAPI();